import { useEffect } from "react";
import { X } from "lucide-react";
import { useWhatsNew } from "./WhatsNewContext";
import { ANNOUNCEMENT } from "../../data/announcements";
import "./WhatsNewModal.css";

// Feature-announcement popup. Visibility + dismissal are driven by
// WhatsNewContext; content comes from data/announcements.js.
function WhatsNewModal() {
  const { open, dismiss } = useWhatsNew();

  // Close on Escape while open.
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") dismiss();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, dismiss]);

  if (!open) return null;

  return (
    <div className="whatsnew-overlay" onClick={dismiss}>
      <div className="whatsnew-card" onClick={(e) => e.stopPropagation()}>
        <button className="whatsnew-close" onClick={dismiss} aria-label="Close">
          <X size={20} />
        </button>

        <div className="whatsnew-header">
          <span className="whatsnew-badge">NEW</span>
          <h2 className="whatsnew-title">{ANNOUNCEMENT.title}</h2>
          {ANNOUNCEMENT.subtitle && (
            <p className="whatsnew-subtitle">{ANNOUNCEMENT.subtitle}</p>
          )}
        </div>

        <ul className="whatsnew-list">
          {ANNOUNCEMENT.features.map((f) => (
            <li className="whatsnew-item" key={f.title}>
              <span className="whatsnew-icon" aria-hidden="true">
                {f.icon}
              </span>
              <div className="whatsnew-item-text">
                <h3 className="whatsnew-item-title">{f.title}</h3>
                <p className="whatsnew-item-desc">{f.description}</p>
              </div>
            </li>
          ))}
        </ul>

        <button className="whatsnew-cta" onClick={dismiss}>
          Got it
        </button>
      </div>
    </div>
  );
}

export default WhatsNewModal;
